import { Injectable } from '@angular/core';
import {NGXLogger} from "ngx-logger";
import {CoreService} from "./core.service";

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  public currentError! : string;
  public currentErrorCode! : string;

  constructor(private logger: NGXLogger,
              private coreService: CoreService) { }
  public showErrorPage(message: string | "", errorCode: string | "") {
    this.logger.debug("ErrorService-Showing error: " + message);
    this.currentError = message;
    this.currentErrorCode = errorCode;
    this.coreService.navigate('/error');
  }
}
